module.exports = __webpack_public_path__ + "assets/83b0faa50156e8ce44429b7247751698.jpg";